import { IFormValidations } from '@aston/foundation';

export const MiddleDomainValidators: IFormValidations = {
};
